import {Injectable} from '@angular/core';
import {HttpHeaders, HttpClient} from '@angular/common/http';

import { API_URL } from './token.service';

@Injectable()
export class _RuleService {
  private url: string = '';

  constructor(private http: HttpClient){ }

  netting(){
    return this.http.get(`${API_URL}/rule/netting`)
  }
  timing(){
    return this.http.get(`${API_URL}/rule/timing`)
  }
  broker_selection(){
    return this.http.get(`${API_URL}/rule/brokerSelection`)
  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/services/rule.service.ts